import { render, staticRenderFns } from "./traficLightIcon.vue?vue&type=template&id=8b6d3b3e&scoped=true&"
import script from "./traficLightIcon.vue?vue&type=script&lang=js&"
export * from "./traficLightIcon.vue?vue&type=script&lang=js&"
import style0 from "./traficLightIcon.vue?vue&type=style&index=0&id=8b6d3b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6d3b3e",
  null
  
)

export default component.exports